import { useRef, useState } from 'react';

export interface IRequestState {
  isInitial: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

export const requestStates = {
  initial: 'initial',
  loading: 'loading',
  success: 'success',
  failed: 'failed',
};


export const useRequestState = (initialValue = requestStates.loading) => {
  const [currentState, setCurrentState] = useState(initialValue);

  const setSuccess = useRef(() => setCurrentState(requestStates.success));
  const setFailed = useRef(() => setCurrentState(requestStates.failed));
  const setLoading = useRef(() => setCurrentState(requestStates.loading));
  const setInitial = useRef(() => setCurrentState(requestStates.initial));

  const state = {
    isFailed: currentState === requestStates.failed,
    isLoading: currentState === requestStates.loading,
    isSuccess: currentState === requestStates.success,
    isInitial: currentState === requestStates.initial,
  };

  return {
    requestState: state,
    setSuccess: setSuccess.current,
    setFailed: setFailed.current,
    setLoading: setLoading.current,
    setInitial: setInitial.current,
  };
};
